import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    Paper,
    Grid,
    TextField,
    Typography
} from '@material-ui/core';

//Components
import {
    Button,
} from 'devextreme-react';

import { CustomBody } from './../shared/CustomBody';
import { FormContainer } from './../shared/FormContainer';

import FormFieldCodiceUtente from './form/FormFieldCodiceUtente';
import FormFieldDataScadenza from './form/FormFieldDataScadenza';

import ConfirmationDialog from './../shared/ConfirmationDialog';
//import Progress from './../shared/Progress';
import ActionProgress from './../shared/ActionProgress';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    paperMain: {
        padding: '10px',
        textAlign: 'center',
        minHeight: "450px",
        position: 'relative',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    formField: {
        minWidth: '100%',
    },
    dividerButton: {
        borderTop: '1px solid #ddd',
        marginTop: '20px',
        padding: '20px !important'
    },
    formContainer: {
        paddingTop: '20px'
    },
    typographyBody1: {
        minWidth: '100%',
        fontSize: '1.1rem'
    }
});

class ModificaLicenzaCmp extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false  //dialog di conferma modifica
        };

        this.changeAndValidateField = this.changeAndValidateField.bind(this);
        this.clearAll = this.clearAll.bind(this);
        this.showDialog = this.showDialog.bind(this);
    }

    showDialog() {
        this.setState({ isOpen: !this.state.isOpen });
    }

    changeAndValidateField(field, newValue) {
        this.props.handleChangeFieldNewData(field, newValue);
        this.props.validateField(field);
    }

    // dopo aver completato la modifica, faccio reset dati e refresh della griglia licenze
    clearAll() {
        //invio email con i dettagli della licenza modificata
        this.props.sendLicenseDetails(this.props.selected_license.ProductKey, null);

        this.props.changeViewSelection('');
        this.props.refreshLicenses(this.props.codiceUtente);
        this.props.resetFilters();
        this.props.resetEditLicenseData();
    }

    render() {
        const { classes, new_license_data, codici_utente, errorText, isChanged, isValid,
            codiceUtente, selected_license, handleChangeFieldNewData, editLicense, editLicenseRequestStatus, editLicenseErrorMessage} = this.props;
        const { isOpen } = this.state;


        return (
            <Paper className={classes.paperMain}>
                <CustomBody>
                    <Grid container spacing={3} className={classes.formContainer} >

                        <FormContainer labelText="Data Scadenza">
                            <FormFieldDataScadenza
                                value={new_license_data.data_scadenza}
                                hasScadenza={new_license_data.hasScadenza}
                                setScadenza={e => handleChangeFieldNewData('hasScadenza', e)}
                                helperText={errorText.data_scadenza}

                                onDataScadenzaChange={e => this.changeAndValidateField('data_scadenza', e)}
                            />
                        </FormContainer>

                        {codiceUtente === 'CODICEADMIN' &&
                            <FormContainer labelText="Codice Utente">
                                <FormFieldCodiceUtente
                                    value={new_license_data.codice_utente}
                                    onCodiceUtenteChange={e => this.changeAndValidateField('codice_utente', e.target.value)}
                                    helperText={errorText.codice_utente}
                                    codici_utente={codici_utente}
                                />
                            </FormContainer>
                        }


                        <FormContainer labelText="Cliente">
                            <TextField
                                className={classes.formField}
                                variant="outlined"
                                size="small"
                                label="Cliente"
                                value={new_license_data.cliente}
                                helperText={errorText.cliente}
                                onChange={(e) => this.changeAndValidateField('cliente', e.target.value)}
                            />
                        </FormContainer>

                        <FormContainer labelText="Email">
                            {codiceUtente === 'CODICEADMIN' ?
                                <TextField
                                    className={classes.formField}
                                    variant="outlined"
                                    size="small"
                                    label="Email"
                                    value={new_license_data.email}
                                    error={errorText.email !== '' ? true : false}
                                    helperText={errorText.email}
                                    onChange={(e) => this.changeAndValidateField('email', e.target.value)}
                                />
                                :
                                <Typography className={classes.typographyBody1} variant="body1">
                                    {new_license_data.email}
                                </Typography>
                            }
                        </FormContainer>

                        <Grid item xs={12} className={`${classes.alignCenter} ${classes.dividerButton}`}>
                            <Button
                                width={120}
                                text="Salva"
                                type="default"
                                stylingMode="contained"
                                disabled={((!isChanged) || !isValid) ? true : false}
                                onClick={() => this.showDialog()}
                            />
                        </Grid>

                        <ConfirmationDialog
                            isOpen={isOpen}
                            showDialog={this.showDialog}
                            title={"Crea Licenza"}
                            message={"Confermi le modifiche effettuate?"}
                            action={() => editLicense(selected_license.ProductKey, this.props.new_license_data)}
                        />
                    </Grid>
                </ CustomBody>
                { /* <Progress /> */}
                <ActionProgress
                    status={editLicenseRequestStatus}
                    errorMessage={editLicenseErrorMessage}
                    tryAgainAction={() => editLicense(selected_license.ProductKey, this.props.new_license_data)}
                    afterResolvedAction={() => this.clearAll()}
                />
            </Paper>
        );

    }
}

ModificaLicenzaCmp.propTypes = {
    //editLicense
    editLicense: PropTypes.func.isRequired,
    editLicenseRequestStatus: PropTypes.string.isRequired,
    editLicenseErrorMessage: PropTypes.string,
    isModified: PropTypes.string.isRequired,

    //sendLicenseDetails
    sendLicenseDetails: PropTypes.func.isRequired,
    sendLicenseDetailsStatus: PropTypes.string.isRequired,
    sendLicenseDetailsErrorMessage: PropTypes.string,
    isSent: PropTypes.string.isRequired,

    new_license_data: PropTypes.shape({
        data_scadenza: PropTypes.any,
        cliente: PropTypes.string,
        email: PropTypes.string,
        codice_utente: PropTypes.string,
    }).isRequired,

    handleChangeFieldNewData: PropTypes.func.isRequired,
    validateField: PropTypes.func.isRequired,

    resetEditLicenseData: PropTypes.func.isRequired,

    isChanged: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,

    errorText: PropTypes.shape({}).isRequired,


    selected_license: PropTypes.shape({
        ProductKey: PropTypes.any,
        ID: PropTypes.any,
        SerialNumberOld: PropTypes.any,
        IDModulo: PropTypes.any,
        Tipologia: PropTypes.any,
        DataDecorr: PropTypes.any,
        DataScadenza: PropTypes.any,
    }).isRequired,

    changeViewSelection: PropTypes.func.isRequired,

    refreshLicenses: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
    
    codiceUtente: PropTypes.string.isRequired,
};

export default withStyles(styles)(ModificaLicenzaCmp);
